import {  MobileTimePicker, MobileTimePickerProps } from "@mui/x-date-pickers-pro";
import { BaseTextFieldProps } from "@mui/material";

import deepMerge from "src/utils/deepMerge.ts";

export interface AavoTimePickerProps extends MobileTimePickerProps, Pick<BaseTextFieldProps, "size"> {
	errorMessage?: string;
}

export const AavoTimePicker = ({ errorMessage, slotProps, size = "small", ...other }: AavoTimePickerProps) => {
	const slotPropsWrapped: MobileTimePickerProps["slotProps"] = deepMerge(
		{
			textField: {
				size: size,
				error: errorMessage !== undefined,
				helperText: errorMessage,
				slotProps: {
					input: {
						sx: {
							minHeight: 0,
						},
					},
				},
			},
		},
		slotProps ?? {},
	);
	return <MobileTimePicker slotProps={slotPropsWrapped} {...other} />;
};
